import { Product } from "./Product";
import { Site } from "./Site";

export class ProductGroupSite {
  constructor(
    site,
    products
  ) {
    /** @type {Site}*/
    this.site = site;
    /** @type {[Product]}*/
    this.products = products;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new ProductGroupSite(
        Site.fromApiObject(input.site),
        Product.fromApiArray(input.products)
      )
    }

    return new ProductGroupSite();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => ProductGroupSite.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [ProductGroupSite.fromApiObject(input)];
    }

    return [];
  }
}